import { render } from "./NavCard.vue?vue&type=template&id=425373a3&scoped=true"
import script from "./NavCard.vue?vue&type=script&lang=js"
export * from "./NavCard.vue?vue&type=script&lang=js"

import "./NavCard.vue?vue&type=style&index=0&id=425373a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425373a3"]])

export default __exports__